import { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col } from "react-bootstrap";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import styles from "./popupView.module.scss";
import classNames from "classnames";

const PopupView: ViewComponent<TradingPlacesViewModel> = observer(({ vm, children }) => (
  <div className={styles.popupViewContainer}>
    <Col xs={12} className={classNames("m-0 p-0", styles.h100)}>
      <div className={classNames("p-4 shadow bg-white rounded", styles.h100, styles.scroll, styles.styledScrollbars)}>
        <div className="d-flex justify-content-end mb-1">
          <Icon
            onClick={vm.closePopover}
            height={18}
            width={18}
            className="text-muted"
            style={{ cursor: "pointer" }}
            icon={IconType.ModalClose}
          />
        </div>
        {children}
      </div>
    </Col>
  </div>
));

export default PopupView;
